import axios, { AxiosError, AxiosInstance, AxiosResponse } from 'axios';
import useAuthStorage from '@/common/store/authStorage/useAuthStorage.ts';
import { BaseResponse } from '@/common/types/ApiResponseTypes.type.ts';

const mainUrl = 'api/v2/app/IRANIAN/adjuster/';
export const BASE_URL =
  (window as any)?.env?.VITE_APP_BASE_URL || import.meta.env.VITE_APP_BASE_URL;
export const fetchApi: AxiosInstance = axios.create({
  baseURL: `${BASE_URL}${mainUrl}`,
});

fetchApi.interceptors.request.use(
  (config) => {
    const token = useAuthStorage.getState().token;
    config.headers.source = 'pwa';
    if (token) {
      config.headers.Authorization = `jwt ${token}`;
    }
    // You can modify the config here if needed
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  },
);

// Add a response interceptor
fetchApi.interceptors.response.use(
  function (response: AxiosResponse<BaseResponse>) {
    return Promise.resolve(response.data.response);
  },
  function (error: AxiosError<BaseResponse>) {
    if (error.config?.signal?.aborted) {
      return Promise.reject({
        fa_details: 'درخواست لغو شد.',
        type: '',
        statusCode: 0,
      });
    }
    if (!error.response) {
      // No response key => something like CORS or Network Error
      return Promise.reject({
        fa_details: 'خطا در برقراری ارتباط با سرور',
        type: 'Network Error',
        statusCode: 500,
      });
    } else if (error.response?.data.error_details) {
      // Our Backend on view (Custom) Error
      return Promise.reject({
        ...error.response.data.error_details,
        statusCode: error.response.status,
      });
    } else {
      // no errorDetailFound on Backend Response
      return Promise.reject({
        fa_details: 'خطایی سمت سرور رخ داده است',
        type: 'Un Recognized Error',
        statusCode: error.response.status,
      });
    }
  },
);
